import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconMapPin = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 10.6667C7 7.90532 9.23858 5.66675 12 5.66675C14.7614 5.66675 17 7.90532 17 10.6667C17 12.5981 15.7343 14.521 14.274 16.0623C13.5644 16.8114 12.8513 17.4258 12.3146 17.8532C12.2008 17.9438 12.0954 18.0257 12 18.0983C11.9046 18.0257 11.7992 17.9438 11.6854 17.8532C11.1487 17.4258 10.4356 16.8114 9.72595 16.0623C8.26574 14.521 7 12.5981 7 10.6667ZM11.4448 20.1651C11.4451 20.1653 11.4453 20.1655 12 19.3334L11.4453 20.1655C11.7812 20.3894 12.2188 20.3894 12.5547 20.1655L12 19.3334C12.5547 20.1655 12.5549 20.1653 12.5552 20.1651L12.5559 20.1647L12.5576 20.1636L12.5626 20.1602L12.5791 20.149C12.5929 20.1397 12.6122 20.1264 12.6368 20.1094C12.6858 20.0755 12.7556 20.0264 12.8433 19.9631C13.0185 19.8366 13.2655 19.6526 13.5604 19.4178C14.1487 18.9494 14.9356 18.2721 15.726 17.4378C17.2657 15.8125 19 13.402 19 10.6667C19 6.80075 15.866 3.66675 12 3.66675C8.13401 3.66675 5 6.80075 5 10.6667C5 13.402 6.73426 15.8125 8.27405 17.4378C9.06439 18.2721 9.85133 18.9494 10.4396 19.4178C10.7345 19.6526 10.9815 19.8366 11.1567 19.9631C11.2444 20.0264 11.3142 20.0755 11.3632 20.1094C11.3878 20.1264 11.4071 20.1397 11.4209 20.149L11.4374 20.1602L11.4424 20.1636L11.4441 20.1647L11.4448 20.1651ZM11 10.6667C11 10.1145 11.4477 9.66675 12 9.66675C12.5523 9.66675 13 10.1145 13 10.6667C13 11.219 12.5523 11.6667 12 11.6667C11.4477 11.6667 11 11.219 11 10.6667ZM12 7.66675C10.3431 7.66675 9 9.00989 9 10.6667C9 12.3236 10.3431 13.6667 12 13.6667C13.6569 13.6667 15 12.3236 15 10.6667C15 9.00989 13.6569 7.66675 12 7.66675Z"
        />
      </svg>
    );
  }
);
